module.exports = __webpack_public_path__ + "blogospherecoupé.jpg?3570b6c782b429f474e76ebab3ce13a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blogospherecoupé.jpg
// module id = 154
// module chunks = 0